import { LockSimple } from "@phosphor-icons/react";
import { REGION_STATUSES } from "@/lib/constants";

const ACTIVE = { off: "bg-white text-foreground shadow-sm", waitlist: "bg-white cw-warning shadow-sm", on: "bg-primary text-white shadow-sm" };

// Segmented Off / Waitlist / On control. Locked (sanctioned) regions can only be Off.
export default function StatusControl({ value, onChange, locked, disabled, labelledBy, testId = "status-control" }) {
  return (
    <div role="radiogroup" aria-labelledby={labelledBy} className="inline-flex rounded-xl bg-[var(--cw-surface-tertiary)] p-1" data-testid={testId}>
      {REGION_STATUSES.map((s) => {
        const blocked = locked && s.key !== "off";
        const active = value === s.key;
        return (
          <button key={s.key} type="button" role="radio" aria-checked={active} disabled={disabled || blocked}
            onClick={() => !active && onChange(s.key)} title={blocked ? "Sanctioned regions are hard-blocked" : undefined}
            className={`inline-flex h-9 items-center gap-1 rounded-lg px-3 text-sm font-medium transition-all cw-ease disabled:cursor-not-allowed ${active ? ACTIVE[s.key] : "cw-soft hover:text-foreground disabled:opacity-40"}`}
            data-testid={`${testId}-${s.key}`}>
            {blocked && <LockSimple size={12} aria-hidden />}{s.label}
          </button>
        );
      })}
    </div>
  );
}
